// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.closing-flex-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: left;
  gap: 10px;
}

.closing-flex-box1 {
  display: flex;
  justify-content: flex-start;
  text-align: left;
}

.closing-pos-input {
  width: 280px !important;
  border: 1px solid lightgray !important;
  border-radius: 7px !important;
  padding: 8px;
  margin-top: 0.5rem !important;
}

.closing-pos-input:focus {
  outline: none;
}

.closing-pos-button {
  background-color: #2954a5 !important;
  color: white !important;
  border-radius: 7px !important;
  float: right;
  margin-top: 10px !important;
}

.day-report-heading {
  text-decoration: underline !important;
}

.current-session-wrapper-box {
  width: 100%;
  padding: 20px;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
}

.dark .current-session-wrapper-box {
  color: #fff !important;
}

.light .css-mxm12o-SingleValue {
  font-weight: 600 !important;
}

.light .css-1rxqsur-ValueContainer {
  font-weight: 600 !important;
}

.dark .css-1rxqsur-ValueContainer {
  font-weight: 600 !important;
}

.dark .css-mxm12o-SingleValue {
  color: black !important;
  font-weight: 400 !important;
  background-color: #2954a5;
  padding: 5px !important;
  border-radius: 10px;
  font-size: 0.9rem !important;
}

.dark .soft-closing-wrapper-select {
  color: #fff !important;
}

.data-I {
  color: #7ed957;
  margin-top: 1.5rem;
  font-size: 1.3rem;
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  font-weight: bolder !important;
}

.dark .data-I {
  color: #7ed957 !important;
}

.order-wrapper-detail-box {
  margin-top: 10px !important;
  padding: 10px !important;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  border-radius: 7px;
  margin-bottom: 10px !important;
}

.session-report-text {
  text-transform: capitalize;
  padding: 5px;
  border-bottom: 1px solid lightgray;
  margin-bottom: 5px;
}

.order-wrapper-inner-details-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.order-wrapper-inner-details-box-I {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  border-top: 1px solid gray;
}

.btn-wrapper-right-box {
  display: flex;
  flex-direction: row-reverse;
}

.order-wrapper-inner-input-box {
  border: none;
  border-bottom: 1px solid #2954a5;
  background-color: transparent;
  text-align: right;
  font-weight: 600;
  font-size: 1rem;
  color: gray;
}

.order-wrapper-inner-input-box:focus {
  outline: none;
  border: 1px solid #2954a5;
  border-radius: 3px;
}

.order-wrapper-detail-box-input {
  padding: 8px;
  width: 99%;
  border: none;
  border-bottom: 1px solid lightgray;
  background-color: transparent;
}

.order-wrapper-detail-box-input:focus {
  outline: none;
  border-bottom: 2px solid #008ace;
}

.dark .order-wrapper-inner-input-box {
  color: #fff !important;
}

.manager-margin {
  margin-right: 20px !important;
}

/* new css  */
.close-session-wrapper-container {
  border-radius: 10px;
  color: #fff;
  font-weight: 600;
  padding: 1rem;
  padding-left: 3.5rem;

  color: #000;
  border: 1px solid rgba(36, 28, 21, 0.15) !important;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  position: relative;
  overflow: hidden;
}

.close-session-wrapper-container:hover {
  border: 1px solid #0562fb !important;
}

.dark .close-session-wrapper-container {
  background-color: #2b2f42;
  color: #fff;
}

.close-session-wrapper-container-I {
  border-radius: 10px;
  font-weight: 600;
  padding: 1rem;
  padding-left: 3.5rem;
  color: #000;
  border: 1px solid rgba(36, 28, 21, 0.15) !important;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  position: relative;
  overflow: hidden;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

/* @media (max-width: 576px) {
  .close-session-wrapper-container-I {
    padding-left: 1.5rem;
  }
} */

.close-session-wrapper-container-I:hover {
  border: 1px solid #0562fb !important;
}

.dark .close-session-wrapper-container-I {
  background-color: #2b2f42;
  color: #fff;
}

.actual-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 0.2rem;
}

/* @media (max-width: 767px) {
  .actual-wrapper > * {
    flex-basis: 40% !important;
  }
  .actual-wrapper {
    flex-wrap: wrap;
  }
} */
.actual-wrapper-inner-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 1;
}

.heading-wrapper-text {
  margin: 0.5rem 0;
  color: #20455e;
  font-size: 16px;
}

.dark .heading-wrapper-text {
  color: #fff;
}

.row-wrapper-text {
  color: #000;
  font-weight: 400;
  min-width: 4rem;
  text-align: end;
}

.dark .row-wrapper-text {
  color: #fff;
}

.total-sum-wrapper-box {
  padding: 1.5rem;
  border-radius: 7px;
  color: #000;
  border: 1px solid rgba(36, 28, 21, 0.15) !important;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  height: 100%;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column !important;
  gap: 0.2rem;
}

.total-sum-wrapper-box:hover {
  border: 1px solid #0562fb !important;
}

.dark .total-sum-wrapper-box {
  background-color: #2b2f42;
  color: #fff;
}

.total-sum-wrapper-box-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
}

.heading-wrapper-text-I {
  margin-top: 1.9rem;
  margin-bottom: 0.5rem;
  color: #20455e;
  font-size: 1.5rem;
}

.dark .heading-wrapper-text-I {
  color: #fff;
}

.settlement-wrapper-container-main {
  padding: 10px;
  border-radius: 7px;
  margin-bottom: 10px !important;
  color: #000;
  border: 1px solid rgba(36, 28, 21, 0.15) !important;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  height: 110px;
  line-height: 1.7;
  position: relative;
  overflow: hidden;
}

.settlement-wrapper-container-main:hover {
  border: 1px solid #0562fb !important;
}

.settlement-wrapper-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.dark .settlement-wrapper-container-main {
  background-color: #2b2f42;
  color: #fff;
}

.circle-bg-image-1 {
  width: 100px;
  height: 110px;
  border-radius: 50%;
  position: absolute;
  background-color: #6492dd;
  overflow: hidden;
  aspect-ratio: 1/1;
  left: -65px;
  top: 0px;
  z-index: 2;
  opacity: 0.2;
}

.circle-bg-image-2 {
  width: 210px;
  height: 210px;
  border-radius: 50%;
  position: absolute;
  background: linear-gradient(#6492dd, #d4eafc, #cde7fc, #d4eafc);
  left: -100px;
  top: 70px;
  overflow: hidden;
  z-index: 1;
  opacity: 0.2;
}

.circle-bg-image-3 {
  width: 100px;
  height: 116px;
  border-radius: 50%;
  position: absolute;
  background-color: #6492dd;
  overflow: hidden;
  aspect-ratio: 1/1;
  left: -65px;
  top: 0px;
  z-index: 2;
  opacity: 0.2;
}

.circle-bg-image-4 {
  width: 210px;
  height: 210px;
  border-radius: 50%;
  position: absolute;
  background: linear-gradient(#6492dd, #d4eafc, #cde7fc, #d4eafc);
  left: -123px;
  top: 66px;
  overflow: hidden;
  z-index: 1;
  opacity: 0.2;
}

.circle-bg-image-5 {
  width: 70px;
  height: 77px;
  border-radius: 50%;
  position: absolute;
  background-color: #6492dd;
  overflow: hidden;
  aspect-ratio: 1/1;
  left: -40px;
  top: 0px;
  z-index: 2;
  opacity: 0.2;
  margin-top: 0.1rem;
}

.circle-bg-image-6 {
  width: 210px;
  height: 210px;
  border-radius: 50%;
  position: absolute;
  background: linear-gradient(#6492dd, #d4eafc, #cde7fc, #d4eafc);
  left: -123px;
  top: 50px;
  overflow: hidden;
  z-index: 1;
  opacity: 0.2;
}

.circle-bg-image-7 {
  width: 210px;
  height: 260px;
  border-radius: 50%;
  position: absolute;
  background-color: #6492dd;
  overflow: hidden;
  aspect-ratio: 1/1;
  left: -150px;
  top: 0px;
  z-index: 2;
  opacity: 0.2;
}

.circle-bg-image-8 {
  width: 210px;
  height: 210px;
  border-radius: 50%;
  position: absolute;
  background: linear-gradient(#6492dd, #d4eafc, #cde7fc, #d4eafc);
  left: -130px;
  top: 170px;
  overflow: hidden;
  z-index: 1;
  opacity: 0.2;
}

.sum-wrapper-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 5px;
}

.amount-text {
  color: #0562fb;
}

.amount-text-I {
  color: #000;
  font-weight: 400;
}

.dark .amount-text-I {
  color: #fff;
}

.note-wrapper-text {
  text-align: center !important;
  font-weight: 900 !important;
}

.note-currency-text {
  text-align: center !important;
  font-weight: 600;
  margin-left: 10px !important;
}

.denomination-input {
  border: none;
  font-size: 0.8rem;
  font-weight: 600;
  text-align: center;
}

.denomination-input:focus {
  outline: none;
}

.confirm-deno-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  float: right;
  margin-top: 10px;
  width: 100%;
}

.confirm-deno-wrapper > button {
  flex: 1;
}

.total-amount-edit-wrapper {
  display: flex;
  align-items: center;
  gap: 2px;
}

.editicons-wrapper {
  color: #2954a5 !important;
  font-size: 1.2em !important;
  cursor: pointer !important;
}

.row-wrapper-text-red {
  color: red !important;
}

.row-wrapper-text-green {
  color: green !important;
}

.aligned-grid-wrapper {
  display: flex;
  align-items: center;
  gap: 1.5rem;
}

.seprate-wrapper-calc-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.seprate-wrapper-calc-container-I {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.seprate-wrapper-image {
  color: #0562fb !important;
  position: absolute;
  left: 1rem;
}

.mrp-text-close-session {
  font-weight: 400;
}

.close-session-right-wrapper {
  display: flex;
  flex-direction: column !important;
  justify-content: space-between;
  gap: 0.3rem;
}

.new-current-session-wrapper-box {
  width: 100%;
  /* margin: 70px 17px 0px 17px; */
  margin-top: 70px;
  /* margin-bottom: 70px; */
  background-color: var(--surface-white);
  border-radius: 8px;
  padding: 12px 16px 8px 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.new-current-session-heading {
  font-size: 1.2rem;
  font-weight: 700;
  margin-bottom: 10px;
}

.newCurrentSessionDetailsSideStyle {
  height: 1.25rem;
  width: 0.5rem;
  background-color: var(--blue-b0);
}

.newCurrentSessionDetailsStyle {
  display: flex;
  gap: 8px;
  align-items: center;
}

.newSessionDetailsHeading {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.newSessionCardContainer {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
}

.newSessionCardContainer {
  margin-top: 8px;
  width: 100%;
}

.newSessionSummaryGrid {
  margin-top: 12px;
}

.new-session-summary-table {
  width: 100%;
  border-collapse: collapse;
}

.new-session-summary-table th {
  padding: 14px;
  /* background-color: var(--surface-g0); */
  padding: 12px;
  text-align: start;
}

.new-session-summary-table td {
  width: 50%;
  border: 1px solid #e5e7eb;
  text-align: left;
  padding: 8px;
}

.heading-wrapper-text-new {
  margin-top: 0.5rem;
  color: var(--surface-g4);
  font-size: 1rem;
}

.currentSessionActionButtonContainer {
  display: flex;
  gap: 8px;
  max-width: 200px;
  margin-top: 8px;
}

.discrepancyAmountMinus {
  color: var(--red-solid);
}

.discrepancyAmountPlus {
  color: var(--green-g0);
}

.newCurrentSessionDetailsContainer {
  display: flex;
  padding: 12px;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  border-radius: 8px;
  background: var(--Blue-25, #edf8ff);
}

.session-details-text-div {
  flex: 1 0 0;
  color: var(--Gray-800, #252b36);

  /* Text sm/Bold */
  font-family: "Outfit", "Inter", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/sessionPage/components/Closing/index.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,sCAAsC;EACtC,6BAA6B;EAC7B,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,qDAAqD;AACvD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,OAAO;EACP,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,2CAA2C;EAC3C,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,gCAAgC;EAChC,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,kCAAkC;EAClC,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,aAAa;AACb;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,oBAAoB;;EAEpB,WAAW;EACX,mDAAmD;EACnD,qDAAqD;EACrD,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,oBAAoB;EACpB,WAAW;EACX,mDAAmD;EACnD,qDAAqD;EACrD,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;;;;GAIG;;AAEH;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;;;;;;;GAOG;AACH;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,OAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,mDAAmD;EACnD,qDAAqD;EACrD,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,iCAAiC;EACjC,WAAW;AACb;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,8BAA8B;EAC9B,WAAW;EACX,mDAAmD;EACnD,qDAAqD;EACrD,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,QAAQ;EACR,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,+DAA+D;EAC/D,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,QAAQ;EACR,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,+DAA+D;EAC/D,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,+DAA+D;EAC/D,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,QAAQ;EACR,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,+DAA+D;EAC/D,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gCAAgC;EAChC,gBAAgB;EAChB,yBAAyB;EACzB,sCAAsC;EACtC,kBAAkB;EAClB,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,yCAAyC;EACzC,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,+BAA+B;;EAE/B,iBAAiB;EACjB,0CAA0C;EAC1C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB","sourcesContent":[".closing-flex-box {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  text-align: left;\n  gap: 10px;\n}\n\n.closing-flex-box1 {\n  display: flex;\n  justify-content: flex-start;\n  text-align: left;\n}\n\n.closing-pos-input {\n  width: 280px !important;\n  border: 1px solid lightgray !important;\n  border-radius: 7px !important;\n  padding: 8px;\n  margin-top: 0.5rem !important;\n}\n\n.closing-pos-input:focus {\n  outline: none;\n}\n\n.closing-pos-button {\n  background-color: #2954a5 !important;\n  color: white !important;\n  border-radius: 7px !important;\n  float: right;\n  margin-top: 10px !important;\n}\n\n.day-report-heading {\n  text-decoration: underline !important;\n}\n\n.current-session-wrapper-box {\n  width: 100%;\n  padding: 20px;\n  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;\n}\n\n.dark .current-session-wrapper-box {\n  color: #fff !important;\n}\n\n.light .css-mxm12o-SingleValue {\n  font-weight: 600 !important;\n}\n\n.light .css-1rxqsur-ValueContainer {\n  font-weight: 600 !important;\n}\n\n.dark .css-1rxqsur-ValueContainer {\n  font-weight: 600 !important;\n}\n\n.dark .css-mxm12o-SingleValue {\n  color: black !important;\n  font-weight: 400 !important;\n  background-color: #2954a5;\n  padding: 5px !important;\n  border-radius: 10px;\n  font-size: 0.9rem !important;\n}\n\n.dark .soft-closing-wrapper-select {\n  color: #fff !important;\n}\n\n.data-I {\n  color: #7ed957;\n  margin-top: 1.5rem;\n  font-size: 1.3rem;\n  display: flex;\n  flex: 1;\n  align-items: center;\n  justify-content: center;\n  font-weight: bolder !important;\n}\n\n.dark .data-I {\n  color: #7ed957 !important;\n}\n\n.order-wrapper-detail-box {\n  margin-top: 10px !important;\n  padding: 10px !important;\n  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\n  border-radius: 7px;\n  margin-bottom: 10px !important;\n}\n\n.session-report-text {\n  text-transform: capitalize;\n  padding: 5px;\n  border-bottom: 1px solid lightgray;\n  margin-bottom: 5px;\n}\n\n.order-wrapper-inner-details-box {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 10px;\n}\n\n.order-wrapper-inner-details-box-I {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 10px;\n  border-top: 1px solid gray;\n}\n\n.btn-wrapper-right-box {\n  display: flex;\n  flex-direction: row-reverse;\n}\n\n.order-wrapper-inner-input-box {\n  border: none;\n  border-bottom: 1px solid #2954a5;\n  background-color: transparent;\n  text-align: right;\n  font-weight: 600;\n  font-size: 1rem;\n  color: gray;\n}\n\n.order-wrapper-inner-input-box:focus {\n  outline: none;\n  border: 1px solid #2954a5;\n  border-radius: 3px;\n}\n\n.order-wrapper-detail-box-input {\n  padding: 8px;\n  width: 99%;\n  border: none;\n  border-bottom: 1px solid lightgray;\n  background-color: transparent;\n}\n\n.order-wrapper-detail-box-input:focus {\n  outline: none;\n  border-bottom: 2px solid #008ace;\n}\n\n.dark .order-wrapper-inner-input-box {\n  color: #fff !important;\n}\n\n.manager-margin {\n  margin-right: 20px !important;\n}\n\n/* new css  */\n.close-session-wrapper-container {\n  border-radius: 10px;\n  color: #fff;\n  font-weight: 600;\n  padding: 1rem;\n  padding-left: 3.5rem;\n\n  color: #000;\n  border: 1px solid rgba(36, 28, 21, 0.15) !important;\n  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;\n  position: relative;\n  overflow: hidden;\n}\n\n.close-session-wrapper-container:hover {\n  border: 1px solid #0562fb !important;\n}\n\n.dark .close-session-wrapper-container {\n  background-color: #2b2f42;\n  color: #fff;\n}\n\n.close-session-wrapper-container-I {\n  border-radius: 10px;\n  font-weight: 600;\n  padding: 1rem;\n  padding-left: 3.5rem;\n  color: #000;\n  border: 1px solid rgba(36, 28, 21, 0.15) !important;\n  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;\n  position: relative;\n  overflow: hidden;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n/* @media (max-width: 576px) {\n  .close-session-wrapper-container-I {\n    padding-left: 1.5rem;\n  }\n} */\n\n.close-session-wrapper-container-I:hover {\n  border: 1px solid #0562fb !important;\n}\n\n.dark .close-session-wrapper-container-I {\n  background-color: #2b2f42;\n  color: #fff;\n}\n\n.actual-wrapper {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  gap: 0.2rem;\n}\n\n/* @media (max-width: 767px) {\n  .actual-wrapper > * {\n    flex-basis: 40% !important;\n  }\n  .actual-wrapper {\n    flex-wrap: wrap;\n  }\n} */\n.actual-wrapper-inner-box {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex: 1;\n}\n\n.heading-wrapper-text {\n  margin: 0.5rem 0;\n  color: #20455e;\n  font-size: 16px;\n}\n\n.dark .heading-wrapper-text {\n  color: #fff;\n}\n\n.row-wrapper-text {\n  color: #000;\n  font-weight: 400;\n  min-width: 4rem;\n  text-align: end;\n}\n\n.dark .row-wrapper-text {\n  color: #fff;\n}\n\n.total-sum-wrapper-box {\n  padding: 1.5rem;\n  border-radius: 7px;\n  color: #000;\n  border: 1px solid rgba(36, 28, 21, 0.15) !important;\n  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;\n  height: 100%;\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column !important;\n  gap: 0.2rem;\n}\n\n.total-sum-wrapper-box:hover {\n  border: 1px solid #0562fb !important;\n}\n\n.dark .total-sum-wrapper-box {\n  background-color: #2b2f42;\n  color: #fff;\n}\n\n.total-sum-wrapper-box-inner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  position: relative;\n}\n\n.heading-wrapper-text-I {\n  margin-top: 1.9rem;\n  margin-bottom: 0.5rem;\n  color: #20455e;\n  font-size: 1.5rem;\n}\n\n.dark .heading-wrapper-text-I {\n  color: #fff;\n}\n\n.settlement-wrapper-container-main {\n  padding: 10px;\n  border-radius: 7px;\n  margin-bottom: 10px !important;\n  color: #000;\n  border: 1px solid rgba(36, 28, 21, 0.15) !important;\n  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;\n  height: 110px;\n  line-height: 1.7;\n  position: relative;\n  overflow: hidden;\n}\n\n.settlement-wrapper-container-main:hover {\n  border: 1px solid #0562fb !important;\n}\n\n.settlement-wrapper-container {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.dark .settlement-wrapper-container-main {\n  background-color: #2b2f42;\n  color: #fff;\n}\n\n.circle-bg-image-1 {\n  width: 100px;\n  height: 110px;\n  border-radius: 50%;\n  position: absolute;\n  background-color: #6492dd;\n  overflow: hidden;\n  aspect-ratio: 1/1;\n  left: -65px;\n  top: 0px;\n  z-index: 2;\n  opacity: 0.2;\n}\n\n.circle-bg-image-2 {\n  width: 210px;\n  height: 210px;\n  border-radius: 50%;\n  position: absolute;\n  background: linear-gradient(#6492dd, #d4eafc, #cde7fc, #d4eafc);\n  left: -100px;\n  top: 70px;\n  overflow: hidden;\n  z-index: 1;\n  opacity: 0.2;\n}\n\n.circle-bg-image-3 {\n  width: 100px;\n  height: 116px;\n  border-radius: 50%;\n  position: absolute;\n  background-color: #6492dd;\n  overflow: hidden;\n  aspect-ratio: 1/1;\n  left: -65px;\n  top: 0px;\n  z-index: 2;\n  opacity: 0.2;\n}\n\n.circle-bg-image-4 {\n  width: 210px;\n  height: 210px;\n  border-radius: 50%;\n  position: absolute;\n  background: linear-gradient(#6492dd, #d4eafc, #cde7fc, #d4eafc);\n  left: -123px;\n  top: 66px;\n  overflow: hidden;\n  z-index: 1;\n  opacity: 0.2;\n}\n\n.circle-bg-image-5 {\n  width: 70px;\n  height: 77px;\n  border-radius: 50%;\n  position: absolute;\n  background-color: #6492dd;\n  overflow: hidden;\n  aspect-ratio: 1/1;\n  left: -40px;\n  top: 0px;\n  z-index: 2;\n  opacity: 0.2;\n  margin-top: 0.1rem;\n}\n\n.circle-bg-image-6 {\n  width: 210px;\n  height: 210px;\n  border-radius: 50%;\n  position: absolute;\n  background: linear-gradient(#6492dd, #d4eafc, #cde7fc, #d4eafc);\n  left: -123px;\n  top: 50px;\n  overflow: hidden;\n  z-index: 1;\n  opacity: 0.2;\n}\n\n.circle-bg-image-7 {\n  width: 210px;\n  height: 260px;\n  border-radius: 50%;\n  position: absolute;\n  background-color: #6492dd;\n  overflow: hidden;\n  aspect-ratio: 1/1;\n  left: -150px;\n  top: 0px;\n  z-index: 2;\n  opacity: 0.2;\n}\n\n.circle-bg-image-8 {\n  width: 210px;\n  height: 210px;\n  border-radius: 50%;\n  position: absolute;\n  background: linear-gradient(#6492dd, #d4eafc, #cde7fc, #d4eafc);\n  left: -130px;\n  top: 170px;\n  overflow: hidden;\n  z-index: 1;\n  opacity: 0.2;\n}\n\n.sum-wrapper-container {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 5px;\n}\n\n.amount-text {\n  color: #0562fb;\n}\n\n.amount-text-I {\n  color: #000;\n  font-weight: 400;\n}\n\n.dark .amount-text-I {\n  color: #fff;\n}\n\n.note-wrapper-text {\n  text-align: center !important;\n  font-weight: 900 !important;\n}\n\n.note-currency-text {\n  text-align: center !important;\n  font-weight: 600;\n  margin-left: 10px !important;\n}\n\n.denomination-input {\n  border: none;\n  font-size: 0.8rem;\n  font-weight: 600;\n  text-align: center;\n}\n\n.denomination-input:focus {\n  outline: none;\n}\n\n.confirm-deno-wrapper {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  float: right;\n  margin-top: 10px;\n  width: 100%;\n}\n\n.confirm-deno-wrapper > button {\n  flex: 1;\n}\n\n.total-amount-edit-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n}\n\n.editicons-wrapper {\n  color: #2954a5 !important;\n  font-size: 1.2em !important;\n  cursor: pointer !important;\n}\n\n.row-wrapper-text-red {\n  color: red !important;\n}\n\n.row-wrapper-text-green {\n  color: green !important;\n}\n\n.aligned-grid-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 1.5rem;\n}\n\n.seprate-wrapper-calc-container {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.seprate-wrapper-calc-container-I {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.seprate-wrapper-image {\n  color: #0562fb !important;\n  position: absolute;\n  left: 1rem;\n}\n\n.mrp-text-close-session {\n  font-weight: 400;\n}\n\n.close-session-right-wrapper {\n  display: flex;\n  flex-direction: column !important;\n  justify-content: space-between;\n  gap: 0.3rem;\n}\n\n.new-current-session-wrapper-box {\n  width: 100%;\n  /* margin: 70px 17px 0px 17px; */\n  margin-top: 70px;\n  /* margin-bottom: 70px; */\n  background-color: var(--surface-white);\n  border-radius: 8px;\n  padding: 12px 16px 8px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.new-current-session-heading {\n  font-size: 1.2rem;\n  font-weight: 700;\n  margin-bottom: 10px;\n}\n\n.newCurrentSessionDetailsSideStyle {\n  height: 1.25rem;\n  width: 0.5rem;\n  background-color: var(--blue-b0);\n}\n\n.newCurrentSessionDetailsStyle {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.newSessionDetailsHeading {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.newSessionCardContainer {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 8px;\n}\n\n.newSessionCardContainer {\n  margin-top: 8px;\n  width: 100%;\n}\n\n.newSessionSummaryGrid {\n  margin-top: 12px;\n}\n\n.new-session-summary-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.new-session-summary-table th {\n  padding: 14px;\n  /* background-color: var(--surface-g0); */\n  padding: 12px;\n  text-align: start;\n}\n\n.new-session-summary-table td {\n  width: 50%;\n  border: 1px solid #e5e7eb;\n  text-align: left;\n  padding: 8px;\n}\n\n.heading-wrapper-text-new {\n  margin-top: 0.5rem;\n  color: var(--surface-g4);\n  font-size: 1rem;\n}\n\n.currentSessionActionButtonContainer {\n  display: flex;\n  gap: 8px;\n  max-width: 200px;\n  margin-top: 8px;\n}\n\n.discrepancyAmountMinus {\n  color: var(--red-solid);\n}\n\n.discrepancyAmountPlus {\n  color: var(--green-g0);\n}\n\n.newCurrentSessionDetailsContainer {\n  display: flex;\n  padding: 12px;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 12px;\n  border-radius: 8px;\n  background: var(--Blue-25, #edf8ff);\n}\n\n.session-details-text-div {\n  flex: 1 0 0;\n  color: var(--Gray-800, #252b36);\n\n  /* Text sm/Bold */\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
